var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitPullRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,4.5a3,3,0,1,0-4.5,2.6V16.9a3,3,0,1,0,3,0V7.1A3,3,0,0,0,9,4.5ZM6,3A1.5,1.5,0,1,1,4.5,4.5,1.5,1.5,0,0,1,6,3Zm0,18a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,6,21Z",
    fill: "#A3AED0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,16.9V7.3a4.3,4.3,0,0,0-4.3-4.3H14.25V1.5a0.75,0.75,0,0,0-1.28-0.53l-3,3a0.75,0.75,0,0,0,0,1.06l3,3A0.75,0.75,0,0,0,14.25,7.5V6h0.94a1.31,1.31,0,0,1,1.31,1.31V16.9a3,3,0,1,0,3,0ZM18,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,18,21Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitPullRequest);
export default __webpack_public_path__ + "static/media/git-pull-request.cfd429f84c7332baf7cde72cc0360911.svg";
export { ForwardRef as ReactComponent };